import { Tab as ReactTab, TabList, TabPanel, Tabs as TabsReact } from 'react-tabs';

import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const List = styled(TabList)`
  display: flex;
`;

const Tabs = styled(TabsReact)`
  border-radius: ${({ theme }) => theme.borderRadius.big2};
`;

const Tab = styled(ReactTab)`
  height: 4.2rem;
  padding: 1.2rem 1.5rem;
  min-width: 10rem;

  border: 0.1rem solid ${pickColor('borderLight')};
  border-top-width: 0.2rem;
  border-color: transparent transparent ${pickColor('borderLight')} transparent;

  color: ${pickColor('black')};

  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${({ selected }) =>
    selected
      ? css`
          border-color: ${pickColor('red')} ${pickColor('borderLight')} transparent
            ${pickColor('borderLight')};
          border-top-width: 0.2rem;
        `
      : null}
`;

const Panel = styled(TabPanel)`
  display: ${({ selected }) => (selected ? 'block' : 'none')};

  padding: 2rem;
  text-transform: capitalize;

  background-color: ${pickColor('white')};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.big};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.big};
  border-top-right-radius: ${({ theme }) => theme.borderRadius.big};
`;

export { Tabs, List, Tab, Panel };
